import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import { set_smoothen_unsmoothen_selected_objects_state, unsmoothen_objects } from '../../uid_continuity';
import { WrappedValue } from '@phi/wrapped-value';
import BarButton from '@components/bar-button';
import unsmoothen_svg from '../../../assets/img/SVG_icons/Top/editing_model/unsmoothen_edges.svg';
import { img } from '@phi/components';
import UnsmoothenTooltip from './UnsmoothenTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const UnsmoothenIcon = unsmoothen_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Unsmoothen objects';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.unsmoothen_state === 'disabled';
        },

        unsmoothen_state() {
            this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
            if (!this.state.loaded)
                return 'disabled';
            const wv_smoothen_state = new WrappedValue<'enabled' | 'disabled' | 'selected'>('disabled');
            const wv_unsmoothen_state = new WrappedValue<'enabled' | 'disabled' | 'selected'>('disabled');
            set_smoothen_unsmoothen_selected_objects_state(wv_smoothen_state, wv_unsmoothen_state);
            return wv_unsmoothen_state.v;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                unsmoothen_objects();
        },
    },

    render() {
        return h(BarButton, {
            id: 'unsmoothen-button',
            tippy: 'left',
            onClick: this.onClick,
            active: this.unsmoothen_state === 'selected',
            disabled: this.disabled,
            selected: this.state.tut_stage === 8,
            help: 'unsmoothen_objects',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(unsmoothen_svg, this.alt),
            tooltip: UnsmoothenTooltip,
        });
    },
});
